import { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useLanguageSettings() {
    const currentLanguage = useSelector(store => store.settings.settingsMetaData.data);
    const [languageContent, setLanguageContent] = useState(null);

    const currentTemplateLanguage = useSelector(store => store.settings.currentTemplateLanguage);
    const [templateLanguageContent, setTemplateLanguageContent] = useState(null);

    useEffect(() => {
        if (currentLanguage?.languageCode) {
            fetchLanguageFile();
        }
    }, [currentLanguage]);

    useEffect(() => {
        if (currentTemplateLanguage?.languageCode) {
            fetchTemplateLanguageFile();
        }
    }, [currentTemplateLanguage]);

    const fetchLanguageFile = async () => {
        try {
            const languageModule = await import(`../../../../public/locales/${currentLanguage.languageCode}.json`);
            setLanguageContent(languageModule);
        } catch (error) {
            setLanguageContent(null);
            console.error("Error loading application language file:", error);
        }
    };

    const fetchTemplateLanguageFile = async () => {
        try {
            const languageModule = await import(`../../../../public/locales/${currentTemplateLanguage.languageCode}.json`);
            setTemplateLanguageContent(languageModule);
        } catch (error) {
            setTemplateLanguageContent(null);
            console.error("Error loading template language file:", error);
        }
    };

    const getLanguageContent = useCallback((page, section) => {
        if (!page && !section) {
            return languageContent;
        } else if (!section) {
            return languageContent[page];
        } else {
            return languageContent[page][section];
        }
    }, [languageContent]);

    const getTemplateLanguageContent = useCallback((page, section) => {
        if (!page && !section) {
            return templateLanguageContent;
        } else if (!section) {
            return templateLanguageContent[page];
        } else {
            return templateLanguageContent[page][section];
        }
    }, [templateLanguageContent]);

    const memoizedLanguageContent = useMemo(() => languageContent, [languageContent]);
    const memoizedTemplateLanguageContent = useMemo(() => templateLanguageContent, [templateLanguageContent]);

    return {
        languageContent: memoizedLanguageContent,
        getLanguageContent,
        templateLanguageContent: memoizedTemplateLanguageContent,
        getTemplateLanguageContent,
    };
}